var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0752 6.4002C7.0752 7.11628 7.35966 7.80304 7.86601 8.30938C8.37235 8.81573 9.05911 9.1002 9.7752 9.1002C10.4913 9.1002 11.178 8.81573 11.6844 8.30938C12.1907 7.80304 12.4752 7.11628 12.4752 6.4002C12.4752 5.68411 12.1907 4.99736 11.6844 4.49101C11.178 3.98466 10.4913 3.7002 9.7752 3.7002C9.05911 3.7002 8.37235 3.98466 7.86601 4.49101C7.35966 4.99736 7.0752 5.68411 7.0752 6.4002ZM19.2252 14.5002C19.2252 15.2163 19.5097 15.903 20.016 16.4094C20.5224 16.9157 21.2091 17.2002 21.9252 17.2002C22.6413 17.2002 23.328 16.9157 23.8344 16.4094C24.3407 15.903 24.6252 15.2163 24.6252 14.5002C24.6252 13.7841 24.3407 13.0974 23.8344 12.591C23.328 12.0847 22.6413 11.8002 21.9252 11.8002C21.2091 11.8002 20.5224 12.0847 20.016 12.591C19.5097 13.0974 19.2252 13.7841 19.2252 14.5002ZM7.0752 22.6002C7.0752 23.3163 7.35966 24.003 7.86601 24.5094C8.37235 25.0157 9.05911 25.3002 9.7752 25.3002C10.4913 25.3002 11.178 25.0157 11.6844 24.5094C12.1907 24.003 12.4752 23.3163 12.4752 22.6002C12.4752 21.8841 12.1907 21.1974 11.6844 20.691C11.178 20.1847 10.4913 19.9002 9.7752 19.9002C9.05911 19.9002 8.37235 20.1847 7.86601 20.691C7.35966 21.1974 7.0752 21.8841 7.0752 22.6002Z",
    stroke: "#1474A1",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22.6004H7.075M12.475 22.6004H28M1 6.40039H7.075M12.475 6.40039H28",
    stroke: "#1474A1",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V28",
    stroke: "#1474A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5H19.225M24.625 14.5H28",
    stroke: "#1474A1",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.76f60326379c50575239ee830e173dfd.svg";
export { ForwardRef as ReactComponent };